import { Button } from '@material-ui/core'
import axios from 'axios'
import React from 'react'
import { useRecoilState } from 'recoil'
import { banksState } from '../recoil/atoms'

const ConfirmBankDelete = props => {
    const [banks, setBanks] = useRecoilState(banksState)
    const deleteHandler = () => {
        axios({
            url: 'accounts/bank/',
            method: "delete",
            data: {
                id: props.id
            }
        }).then(() => {
            setBanks(banks.filter(bank => bank.id !== props.id))
            props.setPopup(false)
        })
    }

    return (
        <>
            <Button
                type="submit"
                variant="contained"
                color="secondary"
                style={{ margin: 10 }}
                onClick={deleteHandler}
            >
                بله
                </Button>
            <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ margin: 10 }}
                onClick={() => props.setPopup(false)}
            >
                خیر
            </Button>
        </>
    )
}

export default ConfirmBankDelete
